import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { CssBaseline, IconButton, Grid, Paper, Tooltip } from '@material-ui/core';
import { VolumeOff as VolumeOffIcon, VolumeUp as VolumeUpIcon } from '@material-ui/icons';

import Gis from '../gis/Gis';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { ScrollTop } from '../ui/ScrollTop';
import { TransitionCurve } from '../charts/TransitionCurve';
import { GisInformation } from '../tables/gisInformation/GisInformation';
import { GisInformationAlarmsTable } from '../tables/gisInformation/GisInformationAlarmsTable';
import { AnnouncersDescriptionTable } from '../tables/announcersTable/AnnouncersDescriptionTable';
import { SelectPoints } from '../ui/SelectPoints';
import { useStyles } from './dashboardStyle';
import { StepChartScreen } from './stepChart/StepChartScreen';
import { sendGeoPointAndGetInfo } from '../../actions/gis';
import { Button } from "@material-ui/core";

import HelpOutlineIcon from '@material-ui/icons//HelpOutline';


const audio = new Audio('./mixkit-alert-quick-chime-766.wav');
audio.loop = true;



export const DashboardScreen = () => {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const fixedHeightPaperTables = clsx(classes.paper, classes.fixedHeightTables);

    const [dashboardReference, setDashboardReference] = useState();
    const [soundAlertPlaying, setSoundAlertPlaying] = useState(false);

    const { width } = useWindowDimensions();
    const [size, setSize] = useState(true);

    //validation for users
    const auth = useSelector(state => state.auth)

    useEffect(() => {
        return () => {
            audio.pause();
            audio.currentTime = 0;
        };
    }, []);

    useEffect(() => {
        if (width <= 768) {
            setSize(false);
        } else {
            setSize(true);
        }
        return size;
    }, [size, width]);

    useEffect(() => {
        if (soundAlertPlaying) {
            audio.play().then();
        } else {
            audio.pause();
            audio.currentTime = 0;
        }
    }, [soundAlertPlaying]);

    const [filters, setFilters] = useState({
        pointName: '',
    });

    /**
     * To select the point name
     * @param {object} fieldName -Object with point name
     * @param {object} newValue -Object with new point name
     */
    const handleChange = (fieldName, newValue) => {
        setFilters((currentFilters) => ({ ...currentFilters, [fieldName]: newValue }));
    };

    return (
        <>
            <CssBaseline />
            <main
                className={classes.content}
                ref={(node) => {
                    if (node) {
                        setDashboardReference(node);
                    }
                }}
            >
                <div className={classes.appBarSpacer} id="GIS" />
             
                <Grid container spacing={3} className={classes.container}>
                    {/* GIS COMPONENT */}
                    <Grid item container spacing={1} xs={12} md={12} lg={12}>
                        <Grid item xs={12} md={6} lg={9}>
                            {!size && <GisInformation realtime />}
                            <Paper className={fixedHeightPaper}>
                                <Gis
                                    playSoundAlert={() => setSoundAlertPlaying(true)}
                                    realtime
                                    stopSoundAlert={() => setSoundAlertPlaying(false)}
                                />
                            </Paper>
                            
                            <Grid container justify="flex-end">
                                <Grid item>
                                    {!soundAlertPlaying ? (
                                        <IconButton disabled size="small">
                                            <VolumeOffIcon />
                                        </IconButton>
                                    ) : (
                                        <Tooltip title="Silenciar alerta actual">
                                            <IconButton onClick={() => setSoundAlertPlaying(false)} size="small">
                                                <VolumeUpIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* TABLES RIGHT SITE*/}
                        <Grid item xs={12} md={6} lg={3}>
                            <Grid container spacing={1} >
                                {size && (
                                    <Grid item xs={12}>
                                        <GisInformation realtime />
                                    </Grid>
                                )}
                                
                                <Grid item xs={12} className="alarms-table" id="table-alarms">
                                    <Paper className={fixedHeightPaperTables}>
                                        <GisInformationAlarmsTable realtime/>
                                    </Paper>
                                    
                                </Grid>

                                {auth.valitadion.announcers === 'True' &&
                                    <Grid item xs={12}  id="table-announcers">
                                        <AnnouncersDescriptionTable realtime />
                                    </Grid>
                                }  

                            {/*<Grid item xs={12} container justifyContent="center" alignItems="center">
                                <IconButton
                                    onClick={() => window.open('https://example.com/document.pdf', '_blank')}
                                >
                                    <HelpOutlineIcon style={{ fontSize: '5rem'}} /> 
                                </IconButton>
                            </Grid>*/ }

                            </Grid>
                        </Grid>
                    </Grid>

                    {/* CHART COMPONENT */}
                    {auth.valitadion.ce === 'True' &&
                        (
                            <Grid item container spacing={1} xs={12} md={12} lg={12}>
                                <Grid item xs={12} md={12} lg={12}>
                                    <SelectPoints 
                                        filters={filters}
                                        handleChange={handleChange}
                                        requestName={'nombreSCE'}
                                    />
                                </Grid>

                                <Grid item xs={12} md={12} lg={12}>
                                    <Paper className={classes.paper}>
                                        <TransitionCurve 
                                            realtime 
                                            namePoint={filters.pointName}
                                        />
                                    </Paper>
                                </Grid>

                               
                            </Grid>

                           
                        )
                    }
                    
                    <StepChartScreen realtime/>
                </Grid>

                <ScrollTop dashboardReference={dashboardReference} />
            </main>
        </>
    );
};
